import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PerfumePage from './pages/PerfumePage';
import OfertasPage from './pages/OfertasPage';
import TestePage from './pages/TestePage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<OfertasPage />} />
        <Route path="/grupo" element={<OfertasPage />} />
        <Route path="/perfume" element={<PerfumePage />} />
        <Route path="/teste" element={<TestePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
